import { useCallback } from "react";
import React, { useState } from "react";
import { useEffect, useRef } from "react";

import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import LockIcon from "@mui/icons-material/Lock";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CropOutlinedIcon from "@mui/icons-material/CropOutlined";
import BrightnessLowIcon from "@mui/icons-material/BrightnessLow";
import AddHomeOutlinedIcon from "@mui/icons-material/AddHomeOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import {
  Box,
  Button,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

import FindProperty from "./FindProprty";
import { Loader } from "../../common/loader";
import PropertyListing from "./PropertyListing";
import { ROLES } from "../../helpers/constants";
import AlertDialog from "../../common/AlertDialog";
import FindPropertyByParcel from "./FindPropertyByParcel";
import FindPropertyComponent from "./FindPropertyComponent";
import UpgradeCategoryProgress from "./UpgradeCategoryProgress";
import OwnershipVerificationModal from "../../common/OwnershipVerificationModal";
import { propertiesAction } from "../../../redux/slices/properties/propertiesSlice";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import {
  decryptPayload,
  buildAdminPropertyCreatePayloadFromStored,
  buildGenerateQuestionsPayload,
  buildSignupPropertiesIdPayload,
  enrichPropertyJsonResponse,
  getObjLength,
  isRiskMeasureWorkspaceProperty,
  normalizePropertyForUpgradeFlow,
  persistSignupMonitoringPropertyIds,
  preparePropertyForUpgradePayment,
  resolveRiskReportIdFromProperty,
  shouldSkipAddPropertyOnUpgrade,
  user_signup_details,
} from "../../helpers/utils";
import { clearPropertySearchMode } from "../../helpers/enhancedMonitoringSearchRules";
import { isAdminEldoradoComplimentaryEnhancedSelected } from "../../helpers/eldoradoSignup";
import { mapCreateUserApiUrl } from "../../for-service-provider/createUserApiPaths";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography sx={{ p: 0 }}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PropertySearchType = ({
  onBtnClick,
  onChangeModalScreen,
  onCloseModalHandler,
  isByPassOptionAvailable = false,
  isAdminCreateUser = false,
  editProperty = false,
  selectedData = {},
  prop_id = null,
  isShow = true,
  handleCloseAddPropertyModal,
  user_id = null,
  isResumeSignup = false,
  selectedRowData = {},
  isAssistant = false,
  isServiceProvider = false,
  enablePaymentScreen = false,
  user_category = "complete_protection",
  backToCategoryWisePricingScreen = () => {},
  isAdmin = false,
  isUpgradeCategory = false,
  userEmail = undefined,
  isTailwindComponent = false,
  isCustomer = false,
  isFromRiskReport = false,
  isUserCreateProperty = false,
  agreementCategory = undefined,
  carriedProperty = null,
}) => {
  const [value, setValue] = useState(1);
  const [propertyValues, setPropertyValues] = useState({});
  const [showPropertyListing, setShowPropertyListing] = useState(false);
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [questionsErrMsg, setQuestionsErrMsg] = useState("");
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
  const [ownershipVerificationModal, setOwnershipVerificationModal] =
    useState(false);
  const [isUpgradeLoader, setIsUpgradeLoader] = useState(true);
  const [carriedActive, setCarriedActive] = useState(
    Boolean(carriedProperty?.property_id),
  );
  const [carriedError, setCarriedError] = useState("");
  const errorMessageRef = useRef(null);
  const carriedRef = useRef(null);
  const handledPropertyQuestionRef = useRef(null);
  // One create/questions request per selected property_id until Search Again
  // clears the selection (prevents add-property-in-report loops).
  const requestedPropertyIdRef = useRef(null);
  const dispatch = useDispatch();
  const user_data = user_signup_details() || selectedRowData;

  // SP client flows (/clients/{id} add property + create client): always bypass
  // questions. Personal /servicer-properties keeps the normal security path.
  useEffect(() => {
    if (isServiceProvider && isAdminCreateUser && isByPassOptionAvailable) {
      dispatch(propertiesAction.setIsQuestionByPass(true));
    }
  }, [dispatch, isAdminCreateUser, isByPassOptionAvailable, isServiceProvider]);
  const [searchedAddress, setSearchedAddress] = useState("");

  const {
    basicMonitoringData,
    basicMonitoringLoader,
    getPropertyData,
    selectedProperty: selectedPropertyData,
    propertyQuestion,
    propertyLoader,
    selectedUserID,
    isQuestionByPass,
    isSubscriptionByPass,
    editPropertiesDetails,
  } = useSelector((state) => state.properties);

  const {
    ownerShipLoader,
    setDefaultOwnerNameDetails,
    bindRiskReportData,
    bindRiskReportLoader,
    verifiedPropertiesList,
    statesCodeList,
    addMultiplePropertiesResponse,
    propertyListLoader,
  } = useSelector((state) => state.signUpUser);

  const accCreated = useSelector((state) => state.signUpUser.createAccResponse);

  const { data: userData } = useSelector(
    (state) => state?.userProfile?.userProfileDetails,
  );
  const { servicerProfessionalDetails, servicerProfileDetails } = useSelector(
    (state) => state?.servicerProfile,
  );
  const storedCategory = decryptPayload(localStorage.getItem("category"));
  // Prefer explicit wizard/parent category (e.g. admin create-user EN) over
  // localStorage, so Parcel/APN stays locked when Enhanced Monitoring was chosen.
  const resolvedSearchCategory =
    agreementCategory || storedCategory || user_category;
  const category = resolvedSearchCategory;

  // Customer /properties Add Property: after /properties search, show the
  // Add Subscription picker. generate-questions waits until Complete Protection
  // Order Summary (PROCEED TO PAYMENT).
  const isCustomerPropertiesAddProperty =
    (Boolean(isUserCreateProperty) || isCustomer) &&
    !isUpgradeCategory &&
    !isAdminCreateUser &&
    !isResumeSignup &&
    !isFromRiskReport;

  console.log(
    "QQ cat-->",
    category,
    storedCategory,
    agreementCategory,
    user_category,
  );

  const dispatchMonitoringOrRiskReport = () => {
    const reportDetails = selectedRowData?.report_details || {};
    let propertyId = reportDetails?.property_id;
    if (!propertyId && reportDetails?.ttb_details) {
      try {
        const ttbDetails = JSON.parse(reportDetails.ttb_details);
        propertyId = ttbDetails?.property_id;
      } catch (e) {
        // ignore invalid ttb_details JSON
      }
    }
    dispatch(
      userSigupAction.bindRiskReport({
        url: "properties/bind-risk-report",
        data: {
          user_id: selectedRowData?.user_id || user_id,
          property_id: propertyId || selectedPropertyData?.property_id,
          risk_report_id: reportDetails?.id,
          step: 2,
          step_key: "GET_MAILING_ADDRESS",
        },
        toekn: true,
      }),
    );
  };

  const handleChange = (event, newValue) => {
    dispatch(propertiesAction.addNewProperty({}));
    setQuestionsErrMsg("");
    setPropertyValues("");
    setErrMsg("");
    setValue(newValue);
  };

  const onBackClick = () => {
    // setPropertyForm(true);
    setShowPropertyListing(false);
    setQuestionsErrMsg("");
    setErrMsg("");
    dispatch(propertiesAction.addNewProperty({}));
    dispatch(propertiesAction.setGeneratedQuestionsData({}));
    dispatch(userSigupAction.clearPropertyQuestion());
    setPropertyValues({});
    setQuestionsErrMsg("");
    setErrMsg("");
  };

  const handleSkipFindPropertyStep = () => {
    dispatch(userSigupAction.showSecurityInfoScreen(false));
    dispatch(propertiesAction.showSecurityInfoScreen(false));
    localStorage.setItem("button", "propertyList");
    onChangeModalScreen("propertyList");
  };

  const handleClose = useCallback(() => {
    if (getPropertyData?.data?.length > 1) {
      setShowPropertyListing(true);
      // setPropertyForm(false);
    }
    if (!propertyQuestion?.success) {
      const apiMessage =
        (typeof propertyQuestion?.data?.message === "string" &&
          propertyQuestion.data.message) ||
        (typeof propertyQuestion?.message === "string" &&
          propertyQuestion.message) ||
        (typeof propertyQuestion?.data === "string" && propertyQuestion.data) ||
        "";
      setQuestionsErrMsg(apiMessage);
      setErrMsg("");
    }
    console.log("falssee=>>");
    setOpen(false);
  }, [
    getPropertyData?.data?.length,
    propertyQuestion?.data,
    propertyQuestion?.message,
    propertyQuestion?.success,
  ]);

  const handleToggle = () => {
    setQuestionsErrMsg("");
    // Always show the pending loader on search; do not toggle off if already open
    // (e.g. after a prior successful single-match search left open=true).
    setOpen(true);
  };

  const validate = () => {
    handleClose();
    setErrMsg(getPropertyData?.data?.message || getPropertyData?.message);
    setQuestionsErrMsg("");
  };

  // APN/address search overlay (`open`) is turned on in handleToggle. Address
  // search closes it via validate(); parcel search did not, so a failed
  // /properties call left the loader spinning.
  useEffect(() => {
    if (!getObjLength(getPropertyData) || getPropertyData?.success) {
      return;
    }
    handleClose();
    setErrMsg(
      getPropertyData?.data?.message ||
        getPropertyData?.message ||
        "No property found for that search.",
    );
  }, [getPropertyData, handleClose]);

  // handle modal open
  const handleResponseModalOpen = () => {
    setIsResponseModalOpen(true);
  };

  // handle modal close
  const handleResponseModalClose = () => {
    setIsResponseModalOpen(false);
  };
  const goToOwnerVerification = () => {
    setOwnershipVerificationModal(false);
    dispatch(propertiesAction.setGeneratedQuestionsData({}));
    onCloseModalHandler("success");
  };

  const openOwnershipVerificationModal = () => {
    handleResponseModalClose();
    setOwnershipVerificationModal(true);
  };

  const selectProperty = (data) => {
    setOpen(true);
    setQuestionsErrMsg("");
    dispatch(propertiesAction.selectedUserPropertyData(data));
    // handleToggle();
  };

  const tabContent = [
    {
      label: "Address",
      value: 1,
      component: (
        <>
          <FindProperty
            onBtnClick={onBtnClick}
            isAdminCreateUser={isAdminCreateUser}
            isByPassOptionAvailable={isByPassOptionAvailable}
            onChangeModalScreen={onChangeModalScreen}
            onCloseModalHandler={onCloseModalHandler}
            setShowPropertyListing={setShowPropertyListing}
            propertyValues={propertyValues}
            selectedData={editPropertiesDetails}
            address={selectedData?.address}
            editProperty={editProperty}
            setPropertyValues={setPropertyValues}
            validate={validate}
            handleToggle={handleToggle}
            handleClose={handleClose}
            questionsErrMsg={questionsErrMsg}
            open={open}
            errMsg={errMsg}
            setErrMsg={setErrMsg}
            isResumeSignup={isResumeSignup}
            selectedRowData={selectedRowData}
            isAssistant={isAssistant}
            isServiceProvider={isServiceProvider}
            backToCategoryWisePricingScreen={backToCategoryWisePricingScreen}
            isAdmin={isResumeSignup ? false : isAdmin}
            isUpgradeCategory={isUpgradeCategory}
            searchedAddress={searchedAddress}
            setSearchedAddress={setSearchedAddress}
            userEmail={userEmail}
            isTailwindComponent={isTailwindComponent}
          />
        </>
      ),
      icon: <FmdGoodOutlinedIcon />,
    },
    {
      label: "Parcel/Land",
      value: 2,
      icon: <CropOutlinedIcon />,
      component: (
        <>
          <FindPropertyByParcel
            onBtnClick={onBtnClick}
            isAdminCreateUser={isAdminCreateUser}
            isByPassOptionAvailable={isByPassOptionAvailable}
            onChangeModalScreen={onChangeModalScreen}
            onCloseModalHandler={onCloseModalHandler}
            setShowPropertyListing={setShowPropertyListing}
            propertyValues={propertyValues}
            setPropertyValues={setPropertyValues}
            validate={validate}
            handleToggle={handleToggle}
            handleClose={handleClose}
            questionsErrMsg={questionsErrMsg}
            open={open}
            errMsg={errMsg}
            setErrMsg={setErrMsg}
            editProperty={editProperty}
            isAssistant={isAssistant}
            isServiceProvider={isServiceProvider}
            isResumeSignup={isResumeSignup}
            backToCategoryWisePricingScreen={backToCategoryWisePricingScreen}
            isAdmin={isResumeSignup ? false : isAdmin}
            userEmail={userEmail}
            isTailwindComponent={isTailwindComponent}
            agreementCategory={agreementCategory}
            category={resolvedSearchCategory}
            categoryChosenBeforeSearch={Boolean(
              isAdminCreateUser || (isAdmin && !isResumeSignup),
            )}
          />
        </>
      ),
    },
  ];

  // The create-client form already searched county records and confirmed the
  // property, so select that record here instead of asking for it again.
  useEffect(() => {
    if (
      !carriedProperty?.property_id ||
      carriedRef.current ||
      editProperty ||
      isUpgradeCategory
    ) {
      if (!carriedProperty?.property_id) {
        carriedRef.current = null;
        setCarriedActive(false);
      }
      return;
    }

    carriedRef.current = { advanced: false };
    setCarriedActive(true);
    setCarriedError("");

    // Re-selecting the same record would run the create request twice.
    if (
      String(selectedPropertyData?.property_id || "") !==
      String(carriedProperty.property_id)
    ) {
      dispatch(propertiesAction.selectedUserPropertyData(carriedProperty));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carriedProperty, dispatch, editProperty, isUpgradeCategory]);

  // Surface a failed create instead of silently dropping back to the search UI.
  useEffect(() => {
    if (
      !carriedActive ||
      !getObjLength(propertyQuestion) ||
      propertyQuestion?.success
    ) {
      return;
    }

    setCarriedError(
      propertyQuestion?.data?.message ||
        propertyQuestion?.message ||
        "We could not add this property to the client's account.",
    );
  }, [carriedActive, propertyQuestion]);

  // When owner questions are bypassed the property is created already verified
  // and the only handoff is a success dialog this flow never renders, so move
  // the wizard on itself.
  useEffect(() => {
    const carried = carriedRef.current;
    if (!carriedActive || !carried || carried.advanced || !isQuestionByPass) {
      return;
    }
    if (!getObjLength(propertyQuestion) || !propertyQuestion?.success) {
      return;
    }

    carried.advanced = true;
    onChangeModalScreen(isAdmin ? "subscriptions" : "propertyList");
  }, [
    carriedActive,
    isAdmin,
    isQuestionByPass,
    onChangeModalScreen,
    propertyQuestion,
  ]);

  useEffect(() => {
    if (
      isFromRiskReport &&
      getObjLength(selectedRowData?.json_last_step) &&
      !getObjLength(verifiedPropertiesList) &&
      (selectedRowData?.json_last_step?.step === 0 ||
        selectedRowData?.json_last_step?.step === 1)
    ) {
      dispatchMonitoringOrRiskReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFromRiskReport]);

  useEffect(() => {
    if (getObjLength(bindRiskReportData)) {
      if (bindRiskReportData?.success && isFromRiskReport) {
        onChangeModalScreen();
        dispatch(userSigupAction.fetchBindRiskReportData({}));
      }
    }
  }, [bindRiskReportData, dispatch, isFromRiskReport, onChangeModalScreen]);

  //============== for call security question api ==============
  useEffect(() => {
    if (!isUpgradeCategory) {
      return;
    }
    if (!getObjLength(statesCodeList)) {
      dispatch(
        userSigupAction.getStateCode({ url: "get-states-code", data: {} }),
      );
    }
  }, [dispatch, isUpgradeCategory, statesCodeList]);

  useEffect(() => {
    if (!isUpgradeCategory) {
      return;
    }
    if (getObjLength(selectedPropertyData)) {
      return;
    }
    if (!getObjLength(selectedRowData)) {
      setIsUpgradeLoader(false);
      return;
    }
    dispatch(
      propertiesAction.selectedUserPropertyData(
        normalizePropertyForUpgradeFlow(selectedRowData, statesCodeList),
      ),
    );
  }, [
    dispatch,
    isUpgradeCategory,
    selectedPropertyData,
    selectedRowData,
    statesCodeList,
  ]);

  useEffect(() => {
    if (!getObjLength(selectedPropertyData)) {
      requestedPropertyIdRef.current = null;
      return;
    }

    const selectedPropertyId = String(selectedPropertyData?.property_id ?? "");
    if (
      selectedPropertyId &&
      requestedPropertyIdRef.current === selectedPropertyId
    ) {
      return;
    }

    if (Object.keys(selectedPropertyData).length > 0) {
      const resolvedUserId =
        (isServiceProvider && !isAdminCreateUser
          ? // Servicer website (/servicer-properties): own personal property only.
            // Main site / admin / customer / add-protection keep the original branches.
            servicerProfileDetails?.data?.user_id || userData?.user_id
          : isAdminCreateUser
            ? // Creating or continuing a client's setup: always the client being
              // set up, never the logged-in admin/servicer account.
              (getObjLength(accCreated) ? accCreated?.data?.user_id : null) ||
              user_id ||
              selectedUserID ||
              userData?.user_id
            : decryptPayload(localStorage.getItem("roles"))?.includes(
                  ROLES.serviceProvider,
                )
              ? servicerProfessionalDetails?.data?.user_id
              : isByPassOptionAvailable
                ? selectedUserID
                : userData?.user_id) || user_id;

      const riskReportId =
        resolveRiskReportIdFromProperty(selectedPropertyData);
      const isStoredRiskMeasure =
        isRiskMeasureWorkspaceProperty(selectedPropertyData);

      let inputParams = buildAdminPropertyCreatePayloadFromStored(
        selectedPropertyData,
        resolvedUserId,
        {
          statesCodeList,
          extra: {
            step: 2,
            step_key: isCustomerPropertiesAddProperty
              ? "GET_MAILING_ADDRESS"
              : category === "complete_protection"
                ? "GENERATE_QUESTIONS"
                : "GET_MAILING_ADDRESS",
          },
        },
      );

      // Customer /properties Add Property: keep the searched property, then
      // open Add Subscription. Do not call generate-questions here.
      if (isCustomerPropertiesAddProperty) {
        if (!inputParams.property_id) {
          setQuestionsErrMsg(
            "We couldn't load property details. Close and try again.",
          );
          return;
        }
        requestedPropertyIdRef.current = selectedPropertyId;
        dispatch(
          propertiesAction.generateQuestionsInputParams({ ...inputParams }),
        );
        handleClose();
        onChangeModalScreen("categoryWisePricing");
        return;
      }

      if (!inputParams.property_id) {
        setIsUpgradeLoader(false);
        setQuestionsErrMsg(
          "We couldn't load property details for this upgrade. Close and try again.",
        );
        return;
      }

      if (!inputParams.state_code) {
        setIsUpgradeLoader(false);
        setQuestionsErrMsg(
          "We couldn't resolve the property state code for this upgrade. Close and try again.",
        );
        return;
      }

      if (!inputParams.muni_code) {
        setIsUpgradeLoader(false);
        setQuestionsErrMsg(
          "We couldn't resolve the property municipality code for this upgrade. Close and try again.",
        );
        return;
      }

      console.log(selectedPropertyData, "security questions==>", inputParams);

      // Lock this property_id before dispatch so dependency re-runs cannot
      // stack duplicate add-property-in-report / create calls.
      requestedPropertyIdRef.current = selectedPropertyId;

      // Unpaid CP already exists — skip create and resume payment.
      if (
        isUpgradeCategory &&
        category === "complete_protection" &&
        shouldSkipAddPropertyOnUpgrade(selectedPropertyData)
      ) {
        const paymentProperty = preparePropertyForUpgradePayment(
          selectedPropertyData,
        );
        if (!paymentProperty?.property_id) {
          setIsUpgradeLoader(false);
          setQuestionsErrMsg(
            "This property is missing the unpaid Complete Protection id. Close and try again.",
          );
          return;
        }
        dispatch(propertiesAction.selectedUserPropertyData(paymentProperty));
        dispatch(
          userSigupAction.setPropertiesId(
            buildSignupPropertiesIdPayload([paymentProperty]),
          ),
        );
        dispatch(
          propertiesAction.setGeneratedQuestionsData({
            success: true,
            message: "Resuming unpaid Complete Protection payment.",
          }),
        );
        setIsUpgradeLoader(false);
        if (isServiceProvider) {
          onCloseModalHandler("success");
        } else {
          onChangeModalScreen();
        }
        return;
      }

      const shouldUseRiskReportAddMultiple =
        isUpgradeCategory &&
        isByPassOptionAvailable &&
        isQuestionByPass &&
        !editProperty &&
        isStoredRiskMeasure &&
        riskReportId;

      if (shouldUseRiskReportAddMultiple) {
        dispatch(
          userSigupAction.addMultipleProperties({
            url: mapCreateUserApiUrl(
              "admin/properties/add-multiple",
              isServiceProvider,
            ),
            token: !isAssistant || isServiceProvider,
            data: {
              user_id: resolvedUserId,
              properties: [
                {
                  id: riskReportId,
                  is_questions_verified_by_admin: true,
                  subscribed_by_admin: Boolean(isSubscriptionByPass),
                },
              ],
              category,
            },
          }),
        );
        return;
      }

      if (isByPassOptionAvailable) {
        if (isQuestionByPass) {
          inputParams.is_questions_verified_by_admin = isQuestionByPass;
          inputParams.subscribed_by_admin = isSubscriptionByPass;
          if (riskReportId) {
            inputParams.risk_report_id = riskReportId;
          }
          if (editProperty) {
            inputParams.prop_id = prop_id;
            dispatch(
              propertiesAction.generateQuestions({
                url: mapCreateUserApiUrl(
                  "admin/edit/property",
                  isServiceProvider,
                ),
                data: inputParams,
                token: !isAssistant || isServiceProvider,
                brokertoken: isAssistant && !isServiceProvider,
              }),
            );
          } else {
            let url = mapCreateUserApiUrl(
              "admin/properties/create",
              isServiceProvider,
            );
            let data = inputParams;
            if (isAssistant && enablePaymentScreen) {
              url = "assistant/check-property-authorization";
              data = {
                user_id: inputParams?.user_id,
                property_id: [inputParams?.property_id],
                // state: selectedProperty?.state,
                property_ids: [
                  {
                    address: inputParams?.address,
                    property_id: inputParams?.property_id,
                    state: inputParams?.state,
                    city: inputParams?.city,
                    zip: inputParams?.zip,
                  },
                ],
              };
            }
            dispatch(
              propertiesAction.generateQuestions({
                url,
                data,
                token: !isAssistant || isServiceProvider,
                brokertoken: isAssistant && !isServiceProvider,
              }),
            );
          }
        } else {
          inputParams.subscribed_by_admin = isSubscriptionByPass;
          if (editProperty) {
            inputParams.prop_id = prop_id;
            console.log("Edit property==>", editProperty);
            dispatch(
              propertiesAction.generateQuestions({
                url: mapCreateUserApiUrl(
                  "admin/edit/property/generate-question",
                  isServiceProvider,
                ),
                data: inputParams,
                token: true,
              }),
            );
          } else {
            let url = mapCreateUserApiUrl(
              "admin/properties/generate-questions",
              isServiceProvider,
            );
            if (isUpgradeCategory && riskReportId) {
              inputParams.risk_report_id = riskReportId;
              if (!isAdmin) {
                url = "properties/generate-questions";
                inputParams.from_resume = true;
              }
            } else if (category !== "complete_protection") {
              url = "properties/add-property-in-report";
              inputParams.category = category;
            }
            dispatch(
              propertiesAction.generateQuestions({
                url,
                data: inputParams,
                token: true,
              }),
            );
          }
        }
      } else {
        // if (localStorage.getItem("roles")?.includes(ROLES.serviceProvider)) {
        //   dispatch(
        //     propertiesAction.generateQuestions({
        //       url: "servicer/generate-question",
        //       data: inputParams,
        //       token: true,
        //     })
        //   );
        // } else
        if (
          userData?.user_type?.includes(ROLES?.professional) &&
          !userData?.role?.includes(ROLES?.customer)
        ) {
          dispatch(
            propertiesAction.generateQuestions({
              url: "professional/generate-question",
              data: inputParams,
              token: true,
            }),
          );
        } else {
          let url = "properties/generate-questions";
          if (isCustomerPropertiesAddProperty) {
            url = "properties/add-property-in-report";
            inputParams.step_key = "GET_MAILING_ADDRESS";
          } else if (category !== "complete_protection") {
            url = "properties/add-property-in-report";
            if (getObjLength(selectedRowData)) {
              inputParams.user_id = selectedRowData?.user_id;
              inputParams.category = category;
            }

            const useAdminBasicMonitoringApi =
              (isAdmin || (isServiceProvider && isAdminCreateUser)) &&
              category === "basic_monitoring";
            if (useAdminBasicMonitoringApi) {
              console.log(selectedRowData, "selectedData==>2");
              // Keep the page loader visible while add-basic-monitoring is pending.
              setOpen(true);
              dispatch(
                propertiesAction.getBasicMonitoringData({
                  url: mapCreateUserApiUrl(
                    "admin/add-basic-monitoring-property",
                    isServiceProvider,
                  ),
                  data: {
                    ...inputParams,
                    source: "equityprotect",
                    user_id:
                      selectedRowData?.user_id ||
                      user_id ||
                      selectedUserID ||
                      inputParams.user_id,
                    step_key: "GET_MAILING_ADDRESS",
                  },
                  type: "post",
                  token: true,
                }),
              );
              return;
            }
          }
          dispatch(
            propertiesAction.generateQuestions({
              url,
              data: inputParams,
              token: true,
            }),
          );
        }
      }
      // Store immediately so Complete Protection PROCEED TO PAYMENT can call
      // generate-questions without waiting on the delayed strip below.
      dispatch(propertiesAction.generateQuestionsInputParams({ ...inputParams }));
      setTimeout(() => {
        delete inputParams.step;
        delete inputParams.step_key;
        dispatch(propertiesAction.generateQuestionsInputParams(inputParams));
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    accCreated,
    dispatch,
    editProperty,
    isAdminCreateUser,
    isByPassOptionAvailable,
    isQuestionByPass,
    isSubscriptionByPass,
    isUpgradeCategory,
    statesCodeList,
    prop_id,
    selectedPropertyData,
    selectedUserID,
    servicerProfessionalDetails?.data?.user_id,
    servicerProfileDetails?.data?.user_id,
    userData?.role,
    userData?.user_id,
    userData?.user_type,
    isServiceProvider,
    isCustomer,
    isFromRiskReport,
    isCustomerPropertiesAddProperty,
  ]);

  useEffect(() => {
    if (!isUpgradeCategory || !getObjLength(addMultiplePropertiesResponse)) {
      return;
    }

    setIsUpgradeLoader(false);
    if (addMultiplePropertiesResponse?.success) {
      dispatch(
        propertiesAction.setGeneratedQuestionsData({
          success: true,
          message: addMultiplePropertiesResponse?.message,
        }),
      );
      dispatch(userSigupAction.clearAddMultiplePropertiesResponse());
      // SP upgrade → subscriptions (Bill me at closing / Client pay now).
      // Admin upgrade keeps the default next-step navigation.
      if (isUpgradeCategory && isServiceProvider) {
        onCloseModalHandler("success");
      } else {
        onChangeModalScreen();
      }
      return;
    }

    dispatch(
      propertiesAction.setGeneratedQuestionsData(addMultiplePropertiesResponse),
    );
    dispatch(userSigupAction.clearAddMultiplePropertiesResponse());
  }, [
    addMultiplePropertiesResponse,
    dispatch,
    isServiceProvider,
    isUpgradeCategory,
    onChangeModalScreen,
    onCloseModalHandler,
  ]);

  useEffect(() => {
    console.log("propertyQuestion  ==>", propertyQuestion);
    if (!propertyQuestion || Object.keys(propertyQuestion).length === 0) {
      handledPropertyQuestionRef.current = null;
      // Upgrade validation errors (missing state/muni codes) are stored in
      // questionsErrMsg before any API response. Clearing them here left the
      // "Setting up upgrade" modal stuck with no loader and no error.
      if (!isUpgradeCategory) {
        setQuestionsErrMsg("");
      }
      return;
    }

    // Parent re-renders recreate onChangeModalScreen/onBtnClick; only handle
    // each propertyQuestion response object once to avoid update loops.
    if (handledPropertyQuestionRef.current === propertyQuestion) {
      return;
    }
    handledPropertyQuestionRef.current = propertyQuestion;

    handleClose();
    if (propertyQuestion?.success) {
      // Enhanced/Basic: keep risk_report_id for payment-enhanced-monitoring
      // before success UI clears propertyQuestion.
      if (category !== "complete_protection") {
        const reportData = propertyQuestion?.data || {};
        const reportId =
          reportData?.risk_report_id ?? reportData?.report_id ?? reportData?.id;
        const propertyId =
          reportData?.property_id || selectedPropertyData?.property_id;
        if (reportId && propertyId) {
          persistSignupMonitoringPropertyIds(dispatch, userSigupAction, {
            ...selectedPropertyData,
            ...reportData,
            id: reportId,
            risk_report_id: reportId,
            report_id: reportId,
            property_id: propertyId,
          });
        }
      }

      // Admin Add Property + Complimentary Enhanced: keep Find Property open so
      // PropertyInfoBox can show; payment-enhanced-monitoring runs on Next.
      const shouldReviewAdminComplimentaryEnhanced =
        (isAdmin || isAdminCreateUser) &&
        category === "enhanced_monitoring" &&
        isAdminEldoradoComplimentaryEnhancedSelected() &&
        !isResumeSignup &&
        !isCustomerPropertiesAddProperty;

      if (shouldReviewAdminComplimentaryEnhanced) {
        return;
      }

      // Admin workspace Add Property + Paid Enhanced: Enhanced has no
      // ownership verification, so go straight to card payment.
      const shouldGoToAdminPaidEnhancedPayment =
        isAdmin &&
        !isServiceProvider &&
        !isAdminCreateUser &&
        !isResumeSignup &&
        !isUpgradeCategory &&
        !isCustomerPropertiesAddProperty &&
        category === "enhanced_monitoring" &&
        user_category === "enhanced_monitoring";

      if (shouldGoToAdminPaidEnhancedPayment) {
        onBtnClick();
        onChangeModalScreen("cardsInfo");
        setIsUpgradeLoader(false);
        return;
      }

      onBtnClick();
      if (isQuestionByPass) {
        if (isUpgradeCategory && isServiceProvider) {
          // SP /clients/{id} upgrade: skip questions → plans/payment choice.
          onCloseModalHandler("success");
        } else if (isUpgradeCategory) {
          onChangeModalScreen();
        } else if (isResumeSignup) {
          // Admin resume signup: after Add Another Property, Owner Verified.
          onChangeModalScreen("propertyList");
        } else if (isAdminCreateUser) {
          // Add Client / Admin create-user: Owner Verification before payment.
          // Tailwind Find Property does not render the success dialog used
          // elsewhere, so advance here instead of waiting for that modal.
          onCloseModalHandler();
        } else {
          handleResponseModalOpen();
        }
        // onCloseModalHandler();
      } else {
        if (
          (isResumeSignup || isAdminCreateUser) &&
          propertyQuestion?.data?.is_verified
        ) {
          // to redirect on the owner verification screen
          onChangeModalScreen("propertyList");
        } else if (isUpgradeCategory) {
          // Admin "No — require security questions": leave the progress
          // modal and open the security questions step.
          onChangeModalScreen("questions");
        } else if (isCustomerPropertiesAddProperty) {
          // Search/add-property-in-report has no questions yet — show plans.
          // generate-questions (after CP Order Summary) is handled from
          // CategoryWisePricing so we do not bounce back to the plan picker.
          if (!propertyQuestion?.data?.questions?.length) {
            onChangeModalScreen("categoryWisePricing");
          }
        } else if (!isCustomer) {
          onChangeModalScreen();
        }
      }
    }

    setIsUpgradeLoader(false);
  }, [
    handleClose,
    isQuestionByPass,
    onBtnClick,
    onChangeModalScreen,
    propertyQuestion,
    isCustomer,
    isUpgradeCategory,
    isAdminCreateUser,
    isResumeSignup,
    isServiceProvider,
    category,
    user_category,
    dispatch,
    selectedPropertyData,
    onCloseModalHandler,
    isAdmin,
    isCustomerPropertiesAddProperty,
    selectedRowData,
    selectedUserID,
    user_id,
  ]);
  //==========================================

  // After state codes load, re-normalize the upgrade property and allow another
  // generate-questions attempt if the first pass lacked state/muni codes.
  useEffect(() => {
    if (!isUpgradeCategory || !getObjLength(statesCodeList)) {
      return;
    }
    const source = getObjLength(selectedPropertyData)
      ? selectedPropertyData
      : selectedRowData;
    if (!getObjLength(source)) {
      return;
    }

    const normalized = normalizePropertyForUpgradeFlow(source, statesCodeList);
    const codesImproved =
      (!source?.state_code && normalized?.state_code) ||
      (!source?.muni_code && normalized?.muni_code);
    if (!codesImproved) {
      return;
    }

    requestedPropertyIdRef.current = null;
    setQuestionsErrMsg("");
    setIsUpgradeLoader(true);
    dispatch(propertiesAction.selectedUserPropertyData(normalized));
  }, [
    dispatch,
    isUpgradeCategory,
    selectedPropertyData,
    selectedRowData,
    statesCodeList,
  ]);

  useEffect(() => {
    if (isAssistant) {
      dispatch(propertiesAction.setIsQuestionByPass(true));
    }
  }, [isAssistant]);

  // Scroll to error message when questionsErrMsg updates
  useEffect(() => {
    if (questionsErrMsg?.length > 0 && errorMessageRef.current) {
      errorMessageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [questionsErrMsg]);

  useEffect(() => {
    if (
      getObjLength(setDefaultOwnerNameDetails) &&
      setDefaultOwnerNameDetails?.success
    ) {
      console.log("setDefaultOwnerNameDetails-->", setDefaultOwnerNameDetails);
      goToOwnerVerification();
      setOwnershipVerificationModal(false);
    }
  }, [setDefaultOwnerNameDetails]);

  useEffect(() => {
    if (!getObjLength(basicMonitoringData)) {
      return;
    }

    if (!basicMonitoringData?.success) {
      setQuestionsErrMsg(
        basicMonitoringData?.message || basicMonitoringData?.data?.message,
      );
      return;
    }

    if (isResumeSignup) {
      onChangeModalScreen();
      dispatch(propertiesAction.fetchBasicMonitoringDetails({}));
      return;
    }

    // Existing-client Add Property (from="add-property"): Basic Monitoring is
    // finished after the add-basic-monitoring API — close via onCloseModalHandler
    // which returns to the client workspace. Create-user signup still uses
    // onCloseModalHandler to continue to Owner Verification (propertyList).
    if (isAdminCreateUser) {
      setOpen(false);
      dispatch(propertiesAction.fetchBasicMonitoringDetails({}));
      onCloseModalHandler?.("success");
    }
  }, [
    basicMonitoringData,
    dispatch,
    isAdminCreateUser,
    isResumeSignup,
    onChangeModalScreen,
    onCloseModalHandler,
  ]);

  if (isUpgradeCategory) {
    const upgradeErrorMessage =
      propertyQuestion?.data?.message ||
      propertyQuestion?.message ||
      addMultiplePropertiesResponse?.data?.message ||
      addMultiplePropertiesResponse?.message ||
      questionsErrMsg ||
      "";
    const upgradeHasError = Boolean(
      (getObjLength(propertyQuestion) && !propertyQuestion?.success) ||
      (getObjLength(addMultiplePropertiesResponse) &&
        !addMultiplePropertiesResponse?.success) ||
      questionsErrMsg,
    );

    return (
      <>
        <UpgradeCategoryProgress
          isLoading={isUpgradeLoader || propertyLoader || propertyListLoader}
          isComplete={
            Boolean(propertyQuestion?.success) ||
            Boolean(addMultiplePropertiesResponse?.success)
          }
          hasError={upgradeHasError}
          skipVerification={isQuestionByPass}
          errorMessage={
            upgradeErrorMessage === "Network Error"
              ? "Could not reach the server. Check that the backend is running, then try again."
              : upgradeErrorMessage
          }
        />
        {upgradeHasError ? (
          <Box sx={{ px: 3, pb: 3, textAlign: "center" }}>
            <Button
              variant="outlined"
              onClick={() => {
                dispatch(propertiesAction.setGeneratedQuestionsData({}));
                dispatch(userSigupAction.clearAddMultiplePropertiesResponse());
                handleCloseAddPropertyModal();
              }}
            >
              Close
            </Button>
          </Box>
        ) : null}
        {getObjLength(propertyQuestion) && propertyQuestion?.success ? (
          <AlertDialog
            type="Success"
            openPopup={isResponseModalOpen}
            onClose={true}
            onCloseFun={() => {
              dispatch(propertiesAction.setGeneratedQuestionsData({}));
              if (
                getObjLength(user_data) &&
                (user_data?.first_owner_first_name?.length > 0 ||
                  user_data?.first_trust_llc_name?.length > 0)
              ) {
                openOwnershipVerificationModal();
              } else {
                handleResponseModalClose();
                onCloseModalHandler("success");
              }
            }}
            mesage={propertyQuestion?.message}
            footer={false}
          />
        ) : null}
      </>
    );
  }
  if (carriedActive) {
    const carriedFailure = carriedError || questionsErrMsg;

    return (
      <div className={isTailwindComponent ? "tailwind_component" : ""}>
        {carriedFailure ? (
          <div className="rounded-xl border border-red-200 bg-red-50 p-5">
            <p className="mb-1 font-medium text-red-900">
              Could not add {carriedProperty?.address || "the property"}
            </p>
            <p className="mb-4 text-sm text-red-800">{carriedFailure}</p>
            <button
              type="button"
              className="rounded-lg bg-white px-4 py-2 text-sm font-medium text-red-900 ring-1 ring-red-300 hover:bg-red-100"
              onClick={() => {
                setCarriedError("");
                setQuestionsErrMsg("");
                setCarriedActive(false);
                dispatch(propertiesAction.addNewProperty({}));
                dispatch(propertiesAction.setGeneratedQuestionsData({}));
                dispatch(userSigupAction.clearPropertyQuestion());
              }}
            >
              Search for the property instead
            </button>
          </div>
        ) : (
          <Loader open={true} />
        )}
      </div>
    );
  }

  if (isTailwindComponent) {
    return (
      <div className="tailwind_component">
        <FindPropertyComponent
          agreementCategory={agreementCategory || user_category}
          onBtnClick={onBtnClick}
          propertyValues={propertyValues}
          setPropertyValues={setPropertyValues}
          validate={validate}
          handleToggle={handleToggle}
          handleClose={handleClose}
          questionsErrMsg={questionsErrMsg}
          open={open}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
          handleChange={handleChange}
          searchedAddress={searchedAddress}
          setSearchedAddress={setSearchedAddress}
          isAdminCreateUser={isAdminCreateUser}
          isByPassOptionAvailable={isByPassOptionAvailable}
          onChangeModalScreen={onChangeModalScreen}
          onCloseModalHandler={onCloseModalHandler}
          editPropertiesDetails={editPropertiesDetails}
          selectedData={selectedData}
          editProperty={editProperty}
          selectedRowData={selectedRowData}
          isResumeSignup={isResumeSignup}
          isAssistant={isAssistant}
          isServiceProvider={isServiceProvider}
          backToCategoryWisePricingScreen={backToCategoryWisePricingScreen}
          isAdmin={isResumeSignup ? false : isAdmin}
          isUpgradeCategory={isUpgradeCategory}
          userEmail={userEmail}
          isTailwindComponent={isTailwindComponent}
          handleCloseAddPropertyModal={handleCloseAddPropertyModal}
          setQuestionsErrMsg={setQuestionsErrMsg}
          isCustomer={isCustomer}
          handleSkip={
            isResumeSignup || isAdminCreateUser
              ? handleSkipFindPropertyStep
              : undefined
          }
        />
        {getObjLength(basicMonitoringData) && !isAdminCreateUser && (
          <AlertDialog
            isTailwindComponent={isTailwindComponent}
            type={basicMonitoringData?.success ? "Success" : "Error"}
            openPopup={true}
            onClose={true}
            onCloseFun={() => {
              if (basicMonitoringData?.success && !isResumeSignup) {
                handleCloseAddPropertyModal?.();
              }
              if (isResumeSignup) {
                onChangeModalScreen();
              }
              dispatch(propertiesAction.fetchBasicMonitoringDetails({}));
            }}
            mesage={
              basicMonitoringData?.message || basicMonitoringData?.data?.message
            }
            footer={false}
          />
        )}
        <Loader
          open={
            basicMonitoringLoader ||
            propertyLoader ||
            ((open || ownerShipLoader) &&
              !isResponseModalOpen &&
              !ownershipVerificationModal &&
              !getObjLength(basicMonitoringData))
          }
        />
      </div>
    );
  }

  return (
    <>
      {isShow && (
        <Typography
          align="center"
          variant="subtitle1"
          className={`py-1 ${isTailwindComponent ? "" : "formHeader"} zoom-container`}
          sx={{
            position: "relative",
            backgroundColor: isTailwindComponent ? "#4ba5dd !important" : "",
            color: "#fff !important",
            borderRadius: "6px 6px 0px 0px",
          }}
        >
          <LockIcon sx={{ fontSize: 16 }} className="me-1" />
          Secure connection
          <Button
            onClick={handleCloseAddPropertyModal}
            className="modal-close-btn close-text hide-inner-close"
            style={{
              position: "absolute",
              top: 0,
              right: -16,
              background: "transparent",
              textTransform: "none",
            }}
          >
            <CloseIcon
              className="hide-inner-close"
              sx={{ fontSize: 20, color: "white" }}
            />
          </Button>
        </Typography>
      )}
      {!showPropertyListing ? (
        <>
          <Box
            className={`${isTailwindComponent ? "tailwind_component" : ""} accountBoxWrapper findPropertyBoxWrapper bg-white`}
            // className="d-flex justify-content-center align-items-center"
            style={{ borderRadius: 10 }}
          >
            <Box className="icon-container">
              <div className="icon-outer-div">
                <div className="icon-inner-div">
                  <AddHomeOutlinedIcon
                    sx={{ fontSize: 24, color: "rgba(3, 149, 255, 1)" }}
                  />
                </div>
              </div>
            </Box>
            <Typography align="center" variant="h3">
              Property Search
            </Typography>
            <Typography
              align="center"
              variant="body1"
              className={isTailwindComponent && "mb-1"}
            >
              Please provide us with the address of the property you would like
              to have monitored and protected.
            </Typography>
            <Box className="d-block d-md-none" margin="0 10px">
              <Select
                value={value}
                onChange={(event) => {
                  setValue(event.target.value);
                }}
                displayEmpty
                className="mobile-select-tabs w-100"
                inputProps={{ "aria-label": "Without label" }}
              >
                {tabContent?.map((tabs, index) => (
                  <MenuItem
                    sx={{
                      color: value === index + 1 ? "#0D120B" : "#0395FF",
                      paddingLeft: value === index + 1 ? "30px" : "",
                    }}
                    value={tabs?.value}
                  >
                    {tabs?.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            {/* <StyledSubTabs
      value={value}
      // scrollButtons
      onChange={handleChange}
      aria-label="basic tabs example"
      className="bg-white d-none d-md-block"
      sx={{ pl: 3, m: 0 }}
    > */}
            <Box className="d-flex justify-content-center align-items-center ">
              <Tabs
                value={value}
                className="bg-white d-none d-md-block"
                onChange={handleChange}
                aria-label="disabled tabs example"
              >
                {tabContent?.map((tabs, index) => (
                  <Tab
                    icon={tabs?.icon}
                    iconPosition="start"
                    value={tabs?.value}
                    label={tabs?.label}
                    {...a11yProps(index + 1)}
                  />
                ))}
              </Tabs>
            </Box>
            <Box>
              {tabContent?.map((tabs, index) => (
                <TabPanel value={value} index={index + 1}>
                  {tabs.component}
                </TabPanel>
              ))}
            </Box>
          </Box>
        </>
      ) : (
        // {/* )} */}
        // {/* {showPropertyListing &&  */}
        <Box className="accountBoxWrapper findPropertyBoxWrapper bg-white">
          <Typography align="center" variant="h3">
            Property List
          </Typography>
          <Typography align="center" variant="body1">
            Please select your relevant property from the property list.
          </Typography>
          {getPropertyData?.data?.map((data, key) => (
            <PropertyListing
              data={data}
              keys={key}
              selectProperty={selectProperty}
              handleToggle={handleToggle}
            />
          ))}
          <div className="text-center stepBtn">
            <Button
              onClick={onBackClick}
              className="backButton"
              color="primary"
              sx={{ mr: 1 }}
            >
              Back
            </Button>
          </div>
          {questionsErrMsg?.length > 0 && (
            <p ref={errorMessageRef} className="text-danger text-center">
              {questionsErrMsg}
            </p>
          )}
        </Box>
      )}

      {isResponseModalOpen && getObjLength(propertyQuestion) && (
        <>
          {getObjLength(propertyQuestion) && propertyQuestion?.success ? (
            <AlertDialog
              type="Success"
              openPopup={isResponseModalOpen}
              onClose={true}
              onCloseFun={() => {
                dispatch(propertiesAction.setGeneratedQuestionsData({}));
                if (
                  getObjLength(user_data) &&
                  (user_data?.first_owner_first_name?.length > 0 ||
                    user_data?.first_trust_llc_name?.length > 0)
                ) {
                  openOwnershipVerificationModal();
                } else {
                  handleResponseModalClose();
                  onCloseModalHandler("success");
                }
              }}
              mesage={propertyQuestion?.message}
              footer={false}
            />
          ) : (
            <AlertDialog
              type="Error"
              openPopup={isResponseModalOpen}
              onClose={true}
              onCloseFun={() => {
                setOwnershipVerificationModal(false);
                handleResponseModalClose();
              }}
              mesage={propertyQuestion?.data?.message}
              footer={false}
            />
          )}
        </>
      )}

      {ownershipVerificationModal && (
        <OwnershipVerificationModal
          isTailwindComponent={isTailwindComponent}
          ownershipVerificationModal={ownershipVerificationModal}
          goToNextStep={goToOwnerVerification}
          property_id={selectedPropertyData?.property_id}
          proeprty_data={selectedPropertyData}
          OwnerName={
            user_data?.first_owner_first_name || user_data?.first_trust_llc_name
          }
        />
      )}

      {getObjLength(basicMonitoringData) && !isAdminCreateUser && (
        <AlertDialog
          isTailwindComponent={isTailwindComponent}
          type={basicMonitoringData?.success ? "Success" : "Error"}
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            if (basicMonitoringData?.success && !isResumeSignup) {
              handleCloseAddPropertyModal?.();
            }
            if (isResumeSignup) {
              onChangeModalScreen();
            }
            dispatch(propertiesAction.fetchBasicMonitoringDetails({}));
          }}
          mesage={
            basicMonitoringData?.message || basicMonitoringData?.data?.message
          }
          footer={false}
        />
      )}

      <Loader
        open={
          basicMonitoringLoader ||
          propertyLoader ||
          ((open || ownerShipLoader || bindRiskReportLoader) &&
            !isResponseModalOpen &&
            !ownershipVerificationModal &&
            !getObjLength(basicMonitoringData))
        }
      />
    </>
  );
};

export default PropertySearchType;
